export const PersianAlphabet = [
  { key: "01", value: "الف" },
  { key: "02", value: "ب" },
  { key: "03", value: "پ" },
  { key: "04", value: "ت" },
  { key: "05", value: "ث" },
  { key: "06", value: "ج" },
  { key: "07", value: "چ" },
  { key: "08", value: "ح" },
  { key: "09", value: "خ" },
  { key: "10", value: "د" },
  { key: "11", value: "ذ" },
  { key: "12", value: "ر" },
  { key: "13", value: "ز" },
  { key: "14", value: "ژ" },
  { key: "15", value: "س" },
  { key: "16", value: "ش" },
  { key: "17", value: "ص" },
  { key: "18", value: "ض" },
  { key: "19", value: "ط" },
  { key: "20", value: "ظ" },
  { key: "21", value: "ع" },
  { key: "22", value: "غ" },
  { key: "23", value: "ف" },
  { key: "24", value: "ق" },
  { key: "25", value: "ک" },
  { key: "26", value: "گ" },
  { key: "27", value: "ل" },
  { key: "28", value: "م" },
  { key: "29", value: "ن" },
  { key: "30", value: "و" },
  { key: "31", value: "هـ" },
  { key: "32", value: "ی" },
  { key: "33", value: "ویلچر" },
];
